import React from 'react';
import { Link } from "react-router-dom";
import { Auth } from 'aws-amplify';
import * as MESSAGES from '../Lib/Messages';
import Spinner from './Spinner';
import Logo from './Logo';
import Notification from './Notification';
import InputError from './InputError';
import Validator from '../Lib/Validator';

class Signin extends React.Component {
	constructor(props) {
		super();
		this.state = {
			rememberMe: false,
			loading: false,
			isConfirmedUser: true,
			errors: {},
			isError: false,
			errorMessage: null
		};

		this.state = {...this.getInitialState(), ...this.state};
		this.handleChange = this.handleChange.bind(this);
		this.handleChangPass = this.handleChangPass.bind(this);
		this.clearForm = this.clearForm.bind(this);
	}

	getInitialState = () => ({
        user: {
			name: '',
            email: '',
            password: '',
			new_password: '',
			confirm_password: '',
        },
	});

	componentDidMount() {
		sessionStorage.clear();
		localStorage.clear();
		const message = this.props.location && this.props.location.state && this.props.location.state.message;
		if(message) {
			this.setState({ errorMessage: message, isError: false });
		}
	}

	handleChange(event) {
		const { target: { name, value } } = event;
		const { user, errors } = this.state;
		user[name] = value;
		this.setState({ user });

		if(errors[name]) {
			delete errors[name];
		}
	}

	handleRememberMe(event) {
		const { target: { checked } } = event;
		this.setState({ rememberMe: checked });
	}

	isValidation() {
		this.setState({errors: {}, errorMessage: ''});
		const { user, isConfirmedUser } = this.state;

		var errors = {};
		var isError = false;
		var validator = new Validator();

		if(isConfirmedUser) {
			if(!validator.required(user.email)) {
				errors['email'] = MESSAGES.ERROR_REQUIRED;
				isError = true;
			} else if(!validator.email(user.email)) {
				errors['email'] = MESSAGES.ERROR_EMAIL;
				isError = true;
			}
			if(!validator.required(user.password)) {
				errors['password'] = MESSAGES.ERROR_REQUIRED;
				isError = true;
			}
		} else {
			if(!validator.required(user.new_password)) {
				errors['new_password'] = MESSAGES.ERROR_REQUIRED;
				isError = true;
			} else if(!validator.minLength(user.new_password, 8)) {
				errors['new_password'] = MESSAGES.ERROR_MINLENGTH;
				isError = true;
			}
			if(!validator.required(user.confirm_password)) {
				errors['confirm_password'] = MESSAGES.ERROR_REQUIRED;
				isError = true;
			} else if(!validator.match(user.new_password, user.confirm_password)) {
				errors['confirm_password'] = MESSAGES.ERROR_CONFIRM_PASS;
				isError = true;
			}
		}

		this.setState({ errors });
		if(isError) {
			return false;
		}

		return true;
	}

	clearForm = () => {
		this.setState(this.getInitialState());
	}

	setAuthData(signInUserSession) {
		const { history } = this.props;
		const { rememberMe } = this.state;
		var payload = signInUserSession.idToken.payload;
		var currentUser = JSON.stringify({
			'sub': payload.sub,
			'name': payload.name,
			'email': payload.email,
		});
		sessionStorage.setItem("isLoggedHandsApp", true);
		if(rememberMe) {
			localStorage.setItem("AuthHandRememberMe", "true");
		} else {
			localStorage.setItem("AuthHandRememberMe", "false");
		}
		localStorage.setItem("AuthHandsApps", currentUser);
		localStorage.setItem("subHandsApps", payload.sub);
		history.push('/');
	}

	handleLogin = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		this.setState({ loading: true });

		const { user } = this.state;
		Auth.signIn(user.email.toLowerCase(), user.password).then(res => {
			const { challengeName, signInUserSession } = res;
			if(challengeName && challengeName === 'NEW_PASSWORD_REQUIRED') {
				this.setState({ isConfirmedUser: false });
			} else {
				this.setAuthData(signInUserSession);
			}
		})
		.catch(err => {
			if(err.message) {
				this.setState({errorMessage: err.message, isError: true});
			}
		});

		this.setState({ loading: false });
	}

	handleChangPass = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		this.setState({ loading: true });

		const { user } = this.state;
		Auth.signIn(user.email.toLowerCase(), user.password).then(res => {
			Auth.completeNewPassword(res, user.new_password)
			.then(user => {
				sessionStorage.clear();
				localStorage.clear();
				this.clearForm();
				this.setState({isConfirmedUser: true});
				this.setState({errorMessage: MESSAGES.SUCCESS_RESET_PASSWORD, isError: false});
				return false;
			})
			.catch(err => {
				if(err.message) {
				  this.setState({errorMessage: err.message, isError: true});
				}
			});
		})
		.catch(err => {
			if(err.message) {
				this.setState({errorMessage: err.message, isError: true});
			}
		});

		this.setState({ loading: false });
	}

	render() {
		const { loading, user, isConfirmedUser, rememberMe, errors, isError, errorMessage } = this.state;
		return (
			<div className="center-sign">
				<Logo />
				<div className="panel card-sign">
					<div className="card-title-sign mt-3 text-right">
						<h2 className="title text-uppercase font-weight-bold m-0">
							<i className="fa fa-user mr-1"></i>
							{isConfirmedUser ? "Sign In" : "Choose New Password"}
						</h2>
					</div>
					<div className={`card-body${loading ? ' loading-overlay-showing' : ''}`}>
                        <Spinner />
						<form method="POST">

							<Notification isError={isError} message={errorMessage} />

				{isConfirmedUser ? (
						<div>
							<div className={`form-group mb-3 ${errors.email ? 'has-danger' : ''}`}>
								<label>Email</label>
								<div className="input-group input-group-icon">
									<input name="email" type="text" className="form-control form-control-lg" value={user.email} onChange={this.handleChange} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-user"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.email} />
							</div>

							<div className={`form-group mb-3 ${errors.password ? 'has-danger' : ''}`}>
								<div className="clearfix">
									<label className="float-left">Password</label>
									<Link role="menuitem" tabIndex="-1" to="/user/forgot_pwd" className="float-right">Lost Password?</Link>
								</div>
								<div className="input-group input-group-icon">
									<input name="password" type="password" className="form-control form-control-lg" value={user.password} onChange={this.handleChange} />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.password} />
							</div>

							<div className="row">
								<div className="col-sm-8">
									<div className="checkbox-custom checkbox-default">
										<input id="RememberMe" name="rememberMe" type="checkbox" checked={`${rememberMe ? 'checked' : ''}`}
										 	onChange={this.handleRememberMe.bind(this)}
										/>
										<label htmlFor="RememberMe">Remember Me</label>
									</div>
								</div>
								<div className="col-sm-4 text-right">
									<button type="submit" className="btn btn-primary mt-2" onClick={this.handleLogin} style={{ marginRight: 0 }}>Sign In</button>
								</div>
							</div>
						</div>
					) : (
						<div>
							<div className={`form-group mb-3 ${errors.new_password ? 'has-danger' : ''}`}>
								<label className="float-left">New Password</label>
								<div className="input-group input-group-icon">
									<input
										  name="new_password" type="password"
										  className="form-control form-control-lg"
										  value={user.new_password}
										  onChange={this.handleChange}
									  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.new_password} />
							</div>

							<div className={`form-group mb-3 ${errors.confirm_password ? 'has-danger' : ''}`}>
								<label className="float-left">Confirm Password</label>
								<div className="input-group input-group-icon">
									<input
										  name="confirm_password" type="password"
										  className="form-control form-control-lg"
										  value={user.confirm_password}
										  onChange={this.handleChange}
									  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.confirm_password} />
							</div>

							<div className="row">
								<div className="col-sm-8">
								</div>
								<div className="col-sm-4 text-right">
									<button type="submit" className="btn btn-primary mt-2" onClick={this.handleChangPass} style={{ marginRight: 0}}>Confirm</button>
								</div>
							</div>
						</div>
					)}

							<p className="text-center mt-3">
								Don't Have an Account? <Link role="menuitem" tabIndex="-1" to="/user/signup">Sign Up</Link>
							</p>
							<br />
						</form>
					</div>
				</div>

				<p className="text-center text-muted mt-3 mb-3">&copy; Copyright 2018. All Rights Reserved.</p>
			</div>
		)
	}
}

export default Signin;
